<template>
  <div>
    <StepModel
      :ui="uiBaseStep"
      :name="STEP_NAMES.supplementaryCard"
      ui-title="Extend the suite of Deem benefits to your family member"
      :ui-subtitle="`Congratulations! You are pre approved for a Deem ${getAppianCardType} Credit Card with a credit limit of AED ${getApproveCreditLimit}! 
      You can also get up to 5 free supplementary cards.`"
      ui-error-message="Please review the fields marked in red"
      :ui-button-text="getMainActionText"
    >
      <!-- <FieldsetModel :ui="uiBaseFieldset" :name="FIELDSET_NAMES.supplementaryInfo" 
      >
        <SupplementaryInfo
          image="/img/assets/card/World Miles Up.jpg"
          title="Supplementary card"
          :desc="`As a ${BRAND.name} Credit Card Holder you are
          eligible for 5 supplementary cards for your family.`"
        />
      </FieldsetModel> -->

      <FieldsetModel
        :ui="uiBaseFieldset"
        :name="FIELDSET_NAMES.supplementaryCards"
        :ui-fake-rerender="getSupplementaryCards.length"
        ui-columns="2"
      >
        <!-- Fieldset render explodes when doesn't have any children -->
        <!-- Which it will be true when there are no supplementary cards -->
        <!-- With this spam we prevent it from exploding -->
        <span />
        <SupplementaryCard
          v-for="(supplementaryCard, index) in getSupplementaryCards"
          :key="`${supplementaryCard.passportID}-${index}`"
          :title="`Supplementary card ${index+1}`"
          :name="supplementaryCard.firstName"
          :amount="`Assigned credit limit: ${supplementaryCard.limit} %`"
          :on-edit="() => editSupplementaryCard(index)"
          :on-remove="() => removeSupplementaryCard(index)"
        />
      </FieldsetModel>
<div v-if="removeAddAnotherButton">
   <FieldsetModel
        :ui="uiBaseFieldset"
        name="addNewSuplementaryCardButton"
        :presence="!showSupplementaryForm"
      >
        <Button
          type="button"
          color="hollow"
          :click="displaySupplementaryForm"
        >{{ getAddButtonText }}</Button>
      </FieldsetModel>
</div>
     

      <FieldsetModel
        :ui="uiBaseFieldset"
        :name="FIELDSET_NAMES.supplementaryCardInfo"
        ui-subtitle="Assign a part of your approved credit limit ot Supplementary Cardholder. Apply now by filling in the below details of Supplementary cardholder"
        ui-columns="2"
        :presence="showSupplementaryForm"
      >
    
        <UiWrapper
            :name="FIELD_NAMES.supplementaryCardFirstName"
            label="First Name"
            :validations="[
          {
            'errorMessage': 'Field contains invalid characters',
            'condition': patternCondition(NAMES_CHARS),
            'name': 'lastname-chars',
          },
        ]"
          >
            <InputText />
          </UiWrapper>
            <UiWrapper
            :name="FIELD_NAMES.supplementaryCardLastName"
            label="Last Name"
            :validations="[
          {
            'errorMessage': 'Field contains invalid characters',
            'condition': patternCondition(NAMES_CHARS),
            'name': 'lastname-chars',
          },
        ]"
          >
            <InputText />
          </UiWrapper>
           
      <UiWrapper :name="FIELD_NAMES.supplementaryCardGender" >
        <Choice :options="GENDER" data-forced-fullwidth="true" />
      </UiWrapper>
 
            <UiWrapper
        :name="FIELD_NAMES.supplementaryBirthDate"
        :label="label"
        :validations="dobValidations"
      >
        <DateWrapper />
      </UiWrapper>
      <UiWrapper
        :name="FIELD_NAMES.supplementaryNationality"
        label="Nationality"
        :validations="[
          {
            'errorMessage': 'This field must not be empty',
            'condition': notEmptyCondition,
            'name': 'nationality-filled',
          },
        ]"
      >
        <Suggest
          :exact-match="true"
          placeholder="Nationality"
          :get-formatted-item="formatMatchedString"
          :get-suggestions="getCountries"
        />+
      </UiWrapper>
       <UiWrapper
          :name="FIELD_NAMES.supplementaryCardEmirates"
          label="Passport Number"
        >
          <InputText type="tel" />
        </UiWrapper>
        <UiWrapper :name="FIELD_NAMES.supplementaryCardRelationship" label="Relationship with you">
          <Dropdown placeholder="Relationship with you" :options="relationshipOptions" />
        </UiWrapper>
        <UiWrapper
            :name="FIELD_NAMES.supplementaryNameOnCard"
            label="Name on the Supplementary Card"
            :validations="[
          {
            'errorMessage': 'Field contains invalid characters',
            'condition': patternCondition(NAMES_CHARS),
            'name': 'lastname-chars',
          },
        ]"
          >
            <InputText />
          </UiWrapper>
            <UiWrapper
            :name="FIELD_NAMES.supplementaryCardLimit"
            label="Credit Limit(as a % of primary cardholder's approved credit limit)"
            :validations="[

          {
             'errorMessage': 'Percentage must be between 10-100',
            'condition': patternCondition(SUPPLEMENTARY_PERCENTAGE),
            'name': 'invalid-chars',
          },

          
            {
                errorMessage: 'Percentage must be between 10-100',
                condition: isValidPercentage,
                name: 'is-valid-percentaged',
              },
          
          
        ]"
      
          >
            <InputText  />
          </UiWrapper>
      </FieldsetModel>

      <FieldsetModel
        :ui="uiBaseFieldset"
        name="saveOrCanceSuplementaryCard"
        :presence="showSupplementaryForm"
      >
        <Button type="button" color="hollow" :click="saveSupplementaryCard">Save</Button>
      </FieldsetModel>
    </StepModel>
  </div>
</template>

<script>
let creditLimit;
import StepModel from "@/lib/components/models/step";
import FieldsetModel from "@/lib/components/models/fieldset";
//import getGoogleTagManager from "@/forms/helpers/google-tag-manager";
import UiWrapper from "@/forms/components/base/ui-wrapper";
import DateWrapper from '@/forms/components/ui-dunia/date-wrapper';
import * as conditions from '@/forms/conditions';
import FIELDSET_NAMES from '@/forms/constants/fieldset-names';

import {
  InputText,
  InputSlide,
  Dropdown,
  SupplementaryInfo,
  SupplementaryCard,
  Button,
  Suggest,
  Choice
} from "@dunia/ui";

import FormComponentMixin from "@/lib/mixins/form-component-mixin";
import sharedComponentMixin from '@/forms/components/shared/shared-component-mixin';
import { END_FORM } from "@/forms/constants/onboarding-logic";

import {
  ADD_SUPPLEMENTARY_CARD,
  EDIT_SUPPLEMENTARY_CARD,
  REMOVE_SUPPLEMENTARY_CARD
} from "@/lib/constants/mutations";

import FIELD_NAMES from "@/forms/constants/field-names";

import flowManager from "@/lib/services/flow-manager";
import {
  
  NAMES_CHARS,MIN_AGE, MAX_AGE,DIGIT_CHARS,SUPPLEMENTARY_CHARS,
  SUPPLEMENTARY_PERCENTAGE
  
} from "@/forms/constants/onboarding-logic";
export default {
  name: "SupplementaryCardStep",

  components: {
    StepModel,
    FieldsetModel,
    UiWrapper,
    InputText,
    InputSlide,
    Dropdown,
    SupplementaryInfo,
    SupplementaryCard,
    Button,
    DateWrapper,
    Suggest,
    Choice
  },
 props: {
    name: {
      type: String,
      default: FIELDSET_NAMES.bornDate,
    },
    title: {
      type: String,
      default: 'Your date of birth',
    },
    label: {
      type: String,
      default: 'Date of Birth',
    },
    dobValidations: {
      type: Array,
      default: () => ([
        {
          errorMessage: 'Please type a past date',
          condition: conditions.isPastDateCondition,
          name: 'birth-is-pastdate',
        },
        // {
        //   errorMessage: 'You must be under 60 years old',
        //   condition: conditions.maxYearCondition(MAX_AGE),
        //   name: 'age-is-under-60',
        // },
        {
          errorMessage: 'You must be at least 21 years old',
          condition: conditions.minYearCondition(MIN_AGE),
          name: 'age-is-above-21',
        },
      ]),
    },
 },
  data: () => ({
    DIGIT_CHARS,
    NAMES_CHARS,
    SUPPLEMENTARY_CHARS,
    SUPPLEMENTARY_PERCENTAGE,
    showSupplementaryForm: false,
    editingSupplementaryCard: -1,
    relationshipOptions: [
      {
        label: "Spouse",
        value: "Spouse"
      },
      {
        label: "Son",
        value: "Son"
      },
      {
        label: "Daughter",
        value: "Daughter"
      },
      {
        label: "Sister",
        value: "Sister"
      },
       {
        label: "Brother",
        value: "Brother"
      },
      {
        label: "Father",
        value: "Father"
      },
      {
        label: "Mother",
        value: "Mother"
      }
    ]
  }),

  mixins: [FormComponentMixin],
  mounted() {

    //getGoogleTagManager();
    var gtagID = process.env.VUE_APP_GA_MEASUREMENT_ID;
    if (gtagID) {
      (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, "script", "dataLayer", `${gtagID}`);
    }
    
  },
  updated(){
       var element = document.getElementsByName(FIELD_NAMES.supplementaryCardLimit)[0];
    if (element) {
    
      element.addEventListener(
        "focusout",
      function() {
       
        this.value= this.value +'%';
        },
        false
      );
    }
  },
  computed: {
    getSupplementaryCards() {
      const { $store } = this;
      const { supplementaryCards } = $store.state.formData;
      return supplementaryCards;
    },

    getAddButtonText() {
      return this.getSupplementaryCards.length >= 1
        ? "Add another"
        : "Add card";
    },

    getMainActionText() {
      return this.getSupplementaryCards.length >= 1 ? "Next" : "No, thanks";
    },
    removeAddAnotherButton(){
      if(this.getSupplementaryCards.length<=4)
      {
        return true;
      }
      else
      {
        return false;
      }
    },
    mappingValueToField() {
      return [
        ["firstName", FIELD_NAMES.supplementaryCardFirstName],
         ["lastName", FIELD_NAMES.supplementaryCardLastName],
          ["gender", FIELD_NAMES.supplementaryCardGender],
           ["dateOfBirth", FIELD_NAMES.supplementaryBirthDate],
           ["nationality",FIELD_NAMES.supplementaryNationality],
        ["relationship", FIELD_NAMES.supplementaryCardRelationship],
        ["passportID", FIELD_NAMES.supplementaryCardEmirates],
        ["nameOnCard",FIELD_NAMES.supplementaryNameOnCard],
        ["limit", FIELD_NAMES.supplementaryCardLimit]
      ];
    },

    getCurrentCardIndex() {
      return this.editingSupplementaryCard !== -1
        ? this.editingSupplementaryCard + 1
        : this.getSupplementaryCards.length + 1;
    },
     getAppianCardType() {
      return this.$store.state.appianCardType;
    },
    getApproveCreditLimit(){
    return this.$store.state.stpPreScreenedAmount 
    },
    getCreditLimitPerentage(){
     return this.fieldValues(FIELD_NAMES.supplementaryCardLimit);
     

    }
  },

  methods: {
    async saveSupplementaryCard(e) {
      e.preventDefault();

      await flowManager.forceValidationsCurrentStep();
      if (!flowManager.isValidCurrentStep) return;

      const card = {};
      this.mappingValueToField.forEach(([name, fieldName]) => {
        card[name] = this.fieldValues(fieldName);
        this.resetFields([fieldName])();
      });

      this.showSupplementaryForm = false;
      let commitToUse = ADD_SUPPLEMENTARY_CARD;

      if (this.editingSupplementaryCard !== -1) {
        card.index = this.editingSupplementaryCard;
        this.editingSupplementaryCard = -1;
        commitToUse = EDIT_SUPPLEMENTARY_CARD;
      }

      const { $store } = this;
      $store.commit(commitToUse, card);
    },

    editSupplementaryCard(index) {
      this.editingSupplementaryCard = index;

      const { $store } = this;
      const cardToEdit =
        $store.state.formData.supplementaryCards[this.editingSupplementaryCard];

      this.mappingValueToField.forEach(([name, fieldName]) => {
        const fieldCard = this.getField(fieldName, { allFields: true });
        fieldCard.onChange(cardToEdit[name]);
      });

      this.$nextTick(function a() {
        this.displaySupplementaryForm();
      });
    },

    removeSupplementaryCard(index) {
      const { $store } = this;
      $store.commit(REMOVE_SUPPLEMENTARY_CARD, index);
    },

    displaySupplementaryForm() {
      this.showSupplementaryForm = true;
    },

    // finishCallback() {
    //   this.showEndPage({
    //     title: "Great!✌️",
    //     actions: [{ click: END_FORM, label: "Go to my account" }]
    //   });
    // }
  },
//   watch:{
//     getCreditLimitPerentage(value)
//     {
// if(value)
// {
// console.log('watch function executed');
// document.getElementsByName('supplementary-card-limit')[0].value='';
// }
//     }

//   }
};
</script>
